// Resolve the backend error code from the several shapes a model-config mutation error can take.
// The admin `apiClient` exposes the code as `error.errorCode` (from `error_code`); the dataProvider
// wraps API errors as `HttpError(message, status, apiError)`, so React Admin's mutation `onError`
// receives the ApiError under `error.body` (which carries `.errorCode`) — and some handlers expose
// `error.body.error_code` directly. Handle all defensively (mirrors VehicleBrandsCreate's switch).
export const resolveErrorCode = (error: any): string | undefined =>
  error?.errorCode ??
  error?.body?.errorCode ??
  error?.body?.error_code ??
  error?.error_code;
